"use client";

import { Button } from "@/components/atoms/buttons";
import ModalTemplate from "@/components/molecules/modal-template";
import { DialogClose } from "@/components/ui/dialog";
import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";

type ConfirmDeleteProps = {
  title: string;
  modalTrigger: React.ReactNode | string;
  onClick?: () => void;
  text: string;
  locale:Locales
};

const ConfirmDeleteModal = ({ title, modalTrigger, onClick, text, locale }: ConfirmDeleteProps) => {
  return (
    <ModalTemplate classNameTitle="font-cabinet-grotesk" title={title} triggerAsChild modalTrigger={modalTrigger}>
      <div className="mx-5 space-y-5 border-t pt-5 pb-5.5">
        <p>{text}</p>
        <div className="flex items-center justify-end gap-2.5">
          <DialogClose asChild>
            <Button variant="secondary" className="h-11" size="md">
              {__("Cancel",locale)}
            </Button>
          </DialogClose>
          <DialogClose asChild>
            <Button size="md" className="h-11" onClick={() => onClick?.()} variant="danger">
                {__("Delete",locale)}
            </Button>
          </DialogClose>
        </div>
      </div>
    </ModalTemplate>
  );
};

export default ConfirmDeleteModal;
